/**
 * Buffer em memória dos últimos erros da sessão (cliente e API), anexado ao
 * feedback como contexto técnico. Guarda só mensagem curta, correlationId,
 * origem e horário — nunca payloads, URLs com query ou dados do usuário.
 */
import { FEEDBACK_MAX_ERROS_RECENTES, type FeedbackErroRecente } from '@patrociconnect/shared';

const MAX_MESSAGE_LENGTH = 160;

const buffer: FeedbackErroRecente[] = [];

export function recordRecentError(entry: { mensagem: string; origem: FeedbackErroRecente['origem']; correlationId?: string }): void {
  const mensagem = entry.mensagem.replace(/\s+/g, ' ').trim().slice(0, MAX_MESSAGE_LENGTH);
  if (!mensagem) return;
  buffer.push({
    mensagem,
    origem: entry.origem,
    em: new Date().toISOString(),
    ...(entry.correlationId && /^[A-Za-z0-9_.:-]{1,128}$/.test(entry.correlationId) ? { correlationId: entry.correlationId } : {}),
  });
  if (buffer.length > FEEDBACK_MAX_ERROS_RECENTES) buffer.splice(0, buffer.length - FEEDBACK_MAX_ERROS_RECENTES);
}

export function getRecentErrors(): FeedbackErroRecente[] {
  return buffer.map((item) => ({ ...item }));
}
